export default function AiSection() {
  return (
    <section className="py-20 md:py-28 bg-gradient-to-br from-[#0f3d32] to-[#1a6b5a] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 items-center">
          {/* Text */}
          <div className="w-full lg:w-[55%] text-white">
            <div className="inline-flex items-center gap-2 bg-white/10 rounded-full px-4 py-2 mb-6">
              <span className="text-sm font-semibold">🤖 AI-консультант</span>
            </div>

            <h2 className="text-3xl md:text-5xl font-extrabold mb-6 leading-tight">
              Поговорите с AI<br />во время перерыва
            </h2>

            <div className="space-y-4 text-white/80 text-base md:text-lg leading-relaxed mb-8">
              <p>
                AI-болит — интерактивный видео-аватар, доступный во время обеденных перерывов обоих дней. Задайте клинический вопрос, протестируйте рекомендации, обсудите с коллегами.
              </p>
              <p>
                Технологии как партнёр врача — не замена, а инструмент. Посмотрите, как AI работает в реальных клинических сценариях.
              </p>
            </div>

            <div className="flex flex-wrap gap-3">
              {['Клинические рекомендации', 'Дифференциальная диагностика', 'Лекарственные взаимодействия', 'Алгоритмы лечения'].map((tag) => (
                <span key={tag} className="bg-white/10 border border-white/20 rounded-full px-4 py-2 text-sm text-white/90">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {/* Video avatar */}
          <div className="w-full lg:w-[45%] flex justify-center">
            <div className="relative flex flex-col items-center">
              <div className="absolute inset-0 flex items-center justify-center overflow-hidden">
                <div className="w-64 h-64 md:w-72 md:h-72 rounded-full border border-[#c8963e]/20 animate-ping" style={{ animationDuration: '3s' }}></div>
              </div>
              <div className="absolute inset-0 flex items-center justify-center overflow-hidden">
                <div className="w-52 h-52 md:w-60 md:h-60 rounded-full border border-[#c8963e]/30 animate-ping" style={{ animationDuration: '2.2s', animationDelay: '0.4s' }}></div>
              </div>

              <div className="relative w-56 h-56 md:w-64 md:h-64 rounded-full overflow-hidden border-4 border-[#c8963e]/60 z-10">
                <div className="absolute inset-0 bg-gradient-to-b from-[#1a6b5a] to-[#0f3d32]"></div>
                <img
                  src="/img/ai-aibolit.png"
                  alt="AI-болит — интерактивный видео-аватар"
                  className="relative z-10 w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0f3d32]/40 via-transparent to-transparent z-20"></div>
              </div>

              <div className="relative z-10 mt-4 flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-5 py-2.5">
                <span className="relative flex h-2.5 w-2.5">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#c8963e] opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#c8963e]"></span>
                </span>
                <span className="text-white text-sm font-semibold">Интерактивный видео-аватар</span>
              </div>

              <div className="relative z-10 mt-3 text-center">
                <div className="text-white font-extrabold text-xl tracking-wide">AI-болит</div>
                <div className="text-white/50 text-sm mt-0.5">Готов ответить на ваш вопрос</div>
              </div>

              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 bg-[#c8963e]/20 rounded-full blur-3xl -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
